module.exports = __webpack_public_path__ + "static/media/pk.0876178b.svg";